import type { Metadata } from "next";

export const metadata: Metadata = {
    title: "Salesense",
    description:
        "Seamlessly integrates ERP with M-Pesa and KRA for efficient business management",
};
